<script setup>
import { $api } from '@/utils/api'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

// Modul AR (Addendum 11 §1) — device kedua menukar kode pairing 6 digit
// (dibuat kasir lewat pos-display/pairing-code) dengan token akses channel
// broadcast. Publik total -- TANPA Sanctum/X-Tenant, tenant & shift
// di-resolve backend dari kode itu sendiri (App\Services\PosDisplayService).
//
// Addendum 16, Modul BY — respons connect() sekarang punya field `mode`.
// Mode 'transaksi' (lama) tetap redirect ke halaman per-shift
// (pos-display-shift-id). Mode 'papan_antrian' (baru) TIDAK punya shift_id
// sama sekali -- redirect ke halaman tenant-wide (pos-display-queue-board).

const router = useRouter()
const route = useRoute()

const code = ref('')
const isSubmitting = ref(false)
const errorMessage = ref('')

const submit = async () => {
  if (code.value.length !== 6)
    return

  isSubmitting.value = true
  errorMessage.value = ''

  try {
    const res = await $api('/public/pos-display/connect', {
      method: 'POST',
      body: { code: code.value },
    })

    const { mode, token, shift_id: shiftId, tenant_id: tenantId } = res.data

    // Modul AS (Addendum 11 §2) — durasi auto-reset ke idle screen "bisa
    // diatur" (requirement §2.1.4) lewat ?idle_seconds= di URL device ini
    // sendiri (mis. dibookmark per-device), diteruskan apa adanya ke halaman
    // display. Tidak diisi -> halaman display pakai default 8 detik sendiri.
    const query = { token, tenant_id: tenantId }
    if (route.query.idle_seconds)
      query.idle_seconds = route.query.idle_seconds

    if (mode === 'papan_antrian') {
      router.replace({ name: 'pos-display-queue-board', query })

      return
    }

    router.replace({
      name: 'pos-display-shift-id',
      params: { shiftId },
      query,
    })
  }
  catch (err) {
    errorMessage.value = err?.data?.message || 'Kode pairing tidak valid atau sudah kedaluwarsa.'
    code.value = ''
  }
  finally {
    isSubmitting.value = false
  }
}
</script>

<template>
  <div
    class="d-flex align-center justify-center"
    style="min-block-size: 100vh;"
  >
    <VCard
      max-width="420"
      class="mx-4 pa-4"
      elevation="4"
    >
      <VCardText class="text-center">
        <VIcon
          icon="ri-tv-2-line"
          size="40"
          class="mb-2"
        />
        <h5 class="text-h5 mb-1">
          Hubungkan Layar Pelanggan
        </h5>
        <p class="text-body-2 text-medium-emphasis mb-6">
          Masukkan kode 6 digit yang ditampilkan di layar kasir.
        </p>

        <VAlert
          v-if="errorMessage"
          type="error"
          variant="tonal"
          class="mb-4 text-start"
          rounded="lg"
        >
          {{ errorMessage }}
        </VAlert>

        <VForm @submit.prevent="submit">
          <VTextField
            v-model="code"
            autofocus
            label="Kode Pairing"
            placeholder="000000"
            maxlength="6"
            inputmode="numeric"
            variant="outlined"
            rounded="lg"
            class="text-center"
            :disabled="isSubmitting"
          />

          <VBtn
            block
            class="mt-4"
            type="submit"
            :loading="isSubmitting"
            :disabled="code.length !== 6"
          >
            Hubungkan
          </VBtn>
        </VForm>
      </VCardText>
    </VCard>
  </div>
</template>
